module.exports = __webpack_public_path__ + "img/Hungary.db31eba9.png";